import { PortfolioRepo as portfolioRepo } from '@services/portfolio.repo';
import { PortfolioUtilities as portfolioUtilities } from '@common/portfolio.utilities';
import { portfolioSelectorService } from '../../portfolioSelector';
import * as echarts from 'echarts';

class PortfolioInternationalCashController implements angular.IOnInit {
  public chartCashHeight: any;
  public cashItems: any;
  public cashTotal: any = 0;
  public selectedCurrency: string;

  public cashPieChart: any;
  public cashPieChartOptions: any;
  public cashPieChartData: any;

  /** @ngInject */
  constructor(private portfolioRepo: portfolioRepo, private portfolioUtilities: portfolioUtilities, private portfolioSelectorService: portfolioSelectorService,
    private $timeout: ng.ITimeoutService, $scope: angular.IScope, private notifyjs) {

    var that = this;

    this.portfolioSelectorService.registerCallback('portfolio.international.cash', () => { this.updateData() }); // Need to wrap it in a fat arrow functiom to get the correctly scoped this


  }

  $onInit() {
    this.updateData();
  }

  public formatCurrency(currencyCode: string) {
    if (!this.portfolioSelectorService.isLoading) {
      return this.portfolioUtilities.formatCurrency(currencyCode);
    } else {
      return "";
    }
  }

  getCashPercentage(cash: any) {
    return (cash.marketValueDisplayCurrency / this.cashTotal) * 100;
  }

  public scrollToElement(elementId: string) {
    var that = this;
    this.$timeout(function () { that.portfolioUtilities.scrollToElement(elementId); }, 220);
  }

  public initialisePieChart() {
    // need to put the initialisation of the pie chart in a function because the dom element is not available till
    // the time you have clicked on the pie chart tab.
    var that = this;
    that.cashPieChart = echarts.init(document.getElementById('cash-pie-chart'));
    that.cashPieChartOptions = {
      tooltip: {
        trigger: 'item',
        formatter: "{b} : {d}%"
      },
      color: ['#489830', '#6cac59', '#91c182'],
      series: {
        type: 'pie',
        radius: ['40%', '70%'],
        center: ['50%', '50%'],
        labelLine: {
          normal: {
            show: true
          }
        },
        data: that.cashPieChartData
      }

    }
    that.cashPieChart.setOption(that.cashPieChartOptions);

  }

  updateData() {
    let that = this;

    this.portfolioSelectorService.setIsLoading(true);

    this.selectedCurrency = this.portfolioSelectorService.getSelectedCurrency();
    // Cash data
    that.portfolioRepo.getPortfolioCashItems(this.selectedCurrency, 'INTERNATIONAL', this.portfolioSelectorService.getSelectedPortfolios())
      .then((val) => {
        this.cashItems = val.data;

        that.scrollToElement('cash');

        that.cashPieChartData = new Array();
        for (var s of this.cashItems) {
          this.cashTotal += s.marketValueDisplayCurrency;
          that.cashPieChartData.push({
            name: s.cashAccount.name,
            value: s.marketValueDisplayCurrency
          });
        }

      })
      .finally(() => {
        this.portfolioSelectorService.setIsLoading(false);
      })
  }
}

export const portfolioInternationalCash: angular.IComponentOptions = {
  template: require('../portfolio.international.cash/portfolio.international.cash.html'),
  controller: PortfolioInternationalCashController
}



// WEBPACK FOOTER //
// ./src/app/portfolio/portfolio.international/portfolio.international.cash/portfolio.international.cash.ts